interface Exercise {
  id: number;
  serie: number;
  rep: string;
  intensity: string; // Mantenemos como string porque en el JSON es un string
  rest: number;
  break: number;
  commentary_custom: string;
  commentary: string;
  exercise: any;
  super_serie: boolean;
  um: string;
  muscle: string;
  evolutions: string;
  first_alternative: string;
}

interface Category {
  exercises: Exercise[];
  min: number;
}

interface Day {
  warm: Category;
  main: Category;
  stretching: Category;
}

interface Plan {
  user_id: number;
  title: string;
  objective: string;
  week: number;
  searchable: boolean;
  is_download: boolean;
  nowPlan: boolean;
  next: boolean;
  days: {
    l: Day;
    m: Day;
    x: Day;
    j: Day;
    v: Day;
    s: Day;
    d: Day;
  };
}

function transformData(inputData: any): Plan {

  // Extraer la secuencia de días desde "day_week"
  const daySequence = inputData?.pCustomize?.day_week
    ?.toLowerCase()
    ?.split?.("-"); // ["l", "x", "v"]
  const daysMapping: { [key: string]: string } = {};
  daySequence.forEach((day: string, index: number) => {
    daysMapping[(index + 1).toString()] = day; // "1" -> "l", "2" -> "x", "3" -> "v"
  });

  const plan: Plan = {
    user_id: 1, // Puedes ajustar esto si tienes un user_id específico
    title: inputData.pCustomize.plan || "Nuevo Plan Personalizado",
    objective: inputData.pCustomize.objective || "Aumentar masa muscular",
    week: parseInt(inputData.pCustomize.week) || 4,
    searchable: inputData.pCustomize.searchable === 1,
    is_download: false, // No hay info en el JSON, dejo valor por defecto
    nowPlan: true, // Valor por defecto
    next: false, // Valor por defecto
    days: {
      l: {
        warm: { exercises: [], min: 0 },
        main: { exercises: [], min: 0 },
        stretching: { exercises: [], min: 0 },
      },
      m: {
        warm: { exercises: [], min: 0 },
        main: { exercises: [], min: 0 },
        stretching: { exercises: [], min: 0 },
      },
      x: {
        warm: { exercises: [], min: 0 },
        main: { exercises: [], min: 0 },
        stretching: { exercises: [], min: 0 },
      },
      j: {
        warm: { exercises: [], min: 0 },
        main: { exercises: [], min: 0 },
        stretching: { exercises: [], min: 0 },
      },
      v: {
        warm: { exercises: [], min: 0 },
        main: { exercises: [], min: 0 },
        stretching: { exercises: [], min: 0 },
      },
      s: {
        warm: { exercises: [], min: 0 },
        main: { exercises: [], min: 0 },
        stretching: { exercises: [], min: 0 },
      },
      d: {
        warm: { exercises: [], min: 0 },
        main: { exercises: [], min: 0 },
        stretching: { exercises: [], min: 0 },
      },
    },
  };

  /* 
  
   "personalized_img": null,
                "personalized_video": null,
  */

  // Procesar las rutinas
  inputData?.routines?.forEach((routine: any) => {
    const dayKey = daysMapping[routine.day];
    if (dayKey) {
      const exercise: Exercise = {
        id: routine.id,
        serie: routine?.serie || 0,
        rep: routine.repetitions.toString(),
        intensity: routine.intensity.toString(), // Devolvemos el número como string directamente
        rest: parseInt(routine.break) || 0,
        break: parseInt(routine.break) || 0,
        commentary_custom: routine.commentary_custom,
        evolutions: routine.evolutions || "",
        commentary: routine.commentary,
        exercise: routine.exercise,
        super_serie:
          routine?.super_serie == "1" || routine?.break == "0" ? true : false,
        um: routine.exercise.um || "Rep",
        muscle: routine.exercise.first_main_muscle || "",
        first_alternative: routine.exercise.first_alternative || "",
      };

      const categoryKey =
        routine.category === "Calentamiento"
          ? "warm"
          : routine.category === "Principal"
            ? "main"
            : "stretching";

      //@ts-ignore
      plan.days[dayKey][categoryKey].exercises.push(exercise);
      //@ts-ignore
      plan.days[dayKey][categoryKey].min += parseInt(routine.break) || 0;
    }
  });

  return plan;
}

export default transformData;
